var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdrLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154px",
    height: "124px",
    viewBox: "0 0 154 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TI logo ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TI-logo-",
    transform: "translate(-0.000000, 0.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1420917,34.5790495 L25.8018925,33.2404679 L25.8018925,22.5181763 C25.8018925,22.5181763 42.544562,29.2227748 80.1214839,0 C80.1214839,0 113.108248,25.7340844 134.898262,23.1884413 C134.898262,23.1884413 135.160062,67.0177324 129.386031,77.740024 C129.386031,77.740024 146.218213,73.6726456 143.95634,63.3965478 C143.220991,60.0325579 141.007243,55.6427118 135.233212,51.6250187 L135.290962,50.5338896 C135.290962,50.5338896 144.878414,55.5024238 146.716787,63.2650278 C148.43196,70.5142166 141.334493,78.8145913 124.657273,82.1620195 L113.835898,84.0383718 C113.835898,84.0383718 126.820971,67.1248969 114.570284,44.5989268 C103.945258,25.0725874 71.6928805,15.3595902 51.7075521,40.2256425 C51.7075521,40.2256425 -2.55525188,39.9362984 3.21877939,77.2022533 C3.21877939,77.2022533 -15.6875877,46.3759084 38.1420917,34.5790495 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1625956,48.1363283 C46.1625956,48.1363283 37.2354177,67.703585 50.0992163,86.2050424 C62.9620524,104.696758 87.953338,106.689042 103.708483,95.6949427 C103.708483,95.6949427 163.009969,93.1736551 150.400271,54.5681445 C150.400271,54.5681445 174.574395,91.1560406 97.631265,101.679591 L110.225564,101.679591 C110.225564,101.679591 97.5581151,115.95682 78.9453102,124 C78.9453102,124 30.922387,105.507311 25.9318299,57.5190641 C25.9318299,57.5190641 -9.25231965,67.4395707 34.9899076,88.7506855 L37.0881553,91.5613171 C37.0881553,91.5613171 13.1912311,84.9979808 9.64634746,70.5229846 C6.11878876,56.0479883 44.1942852,47.732026 46.1625956,48.1363283 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1936505,60.9337136 C53.1936505,60.9337136 69.1769082,39.456981 96.6110161,51.525648 L94.3318186,38.0180545 C94.3318186,38.0180545 76.8461,28.6606485 61.7858787,43.2350154 C57.8492579,47.0539672 54.9251861,52.2952837 53.1936505,60.9337136 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9094272,40.2090807 C97.9094272,40.2090807 107.521904,65.8194389 83.3882054,83.7909193 L95.9411168,88.6600828 C95.9411168,88.6600828 100.09815,86.6093447 103.626671,81.905799 C110.216901,73.118313 115.975533,56.8906907 97.9094272,40.2090807 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7687567,90.0571177 C93.7687567,90.0571177 67.1681729,86.2459597 63.4519644,55.9817412 L53.202313,64.8354743 C53.202313,64.8354743 53.2918254,70.853246 56.2245597,76.9703884 C58.2823825,81.2608638 61.5404415,85.3038867 66.3596738,88.3707388 C72.590892,92.3299786 82.4815314,95.1240484 93.7687567,90.0571177 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdrLogoSmall);
export default __webpack_public_path__ + "static/media/MDRLogoSmall.12b585dd2f5cfaee98c78c2994dcc25b.svg";
export { ForwardRef as ReactComponent };